import { AppSelect, type AppSelectProps } from '~/components/new/app-ui/app-select'
import { useFieldContext } from '~/hooks/form-hooks'
import { Field, type FieldProps } from './field'

type SelectFieldProps<TValue> = Omit<AppSelectProps<TValue>, 'value'> &
  Omit<FieldProps, 'children' | 'error' | 'id'>

export function SelectField<TValue>({
  label,
  optional,
  required,
  className,
  ...props
}: SelectFieldProps<TValue>) {
  const field = useFieldContext<TValue | null>()

  const errorMessage = (field.state.meta.errors as { message: string }[]).at(0)?.message
  return (
    <Field
      id={field.name}
      label={label}
      error={errorMessage}
      optional={optional}
      required={required}
      className={className}
    >
      <AppSelect
        {...props}
        className="w-full rounded-lg"
        id={field.name}
        value={field.state.value}
        ariaInvalid={errorMessage !== undefined}
        onChange={(v) => field.handleChange(v ?? null)}
      />
    </Field>
  )
}
